import { createContext, useContext, useState } from 'react';
import { ChildrenOnly } from '../types/ChildrenOnly';
import { useScrollLock } from './useScrollLock';

const ScrollLockContext = createContext<ScrollLockContextState>({
  locked: false,
  setLocked: (value: boolean) => value,
});

export const useStatefulScrollLock = () => useContext(ScrollLockContext);

interface ScrollLockContextState {
  locked: boolean;
  setLocked: (value: boolean) => void;
}

export const ScrollLockProvider = ({ children }: ChildrenOnly) => {
  const [locked, setLocked] = useState<boolean>(false);
  const { allowScroll, lockScroll } = useScrollLock();

  const handleScrollLock = (lock: boolean) => {
    if (lock) lockScroll();
    else allowScroll();

    setLocked(lock);
  };

  return (
    <ScrollLockContext.Provider value={{ locked, setLocked: handleScrollLock }}>
      {children}
    </ScrollLockContext.Provider>
  );
};
